import { authHeader } from "@/services/auth";
import { isoStringToNormalDate } from "@/services/util.service";
//import { doPostOne } from "@/services/incident.service";
//import { resetAuthUser } from "@/services/auth";
//import { loginInterrupt } from "@/services/nav";
import store from "@/stores/index";
const vueOrgId = import.meta.env.VITE_APP_ORGANIZATION_ID;

export const gqlHandleError = async (error, params, url) => {
  console.log("GraphQL error handler called", error);

  const userAgent = navigator;
  const currentdate = await isoStringToNormalDate();

  let status = error?.status || 500;
  let description = "Unexpected error while communicating with the cloud";
  let metadataError = "";

  if (error?.graphQLErrors && error.graphQLErrors.length > 0) {
    const gqlError = error.graphQLErrors[0];

    const isGraphqlAuthError =
      gqlError?.extensions?.category == "graphql-authentication";
    if (isGraphqlAuthError) {
      //  resetAuthUser();
      /*  loginInterrupt(
          window.location.href,
          "There was an access violation caused by your request. You need to sign back in please.",
        );*/
      store.dispatch("auth/triggerLoginPopup",
        "Your session has expired. Please log back in to continue.<br>You may return home, but you will lose your progress."
      );
    }

    status = 200;
    description = gqlError.message || "GraphQL API Error";
    metadataError = JSON.stringify(gqlError);
  } else if (error?.response) {
    status = error.response.status;
    description = "Storefront Error " + status;
    try {
      metadataError = await error.response.text();
    } catch {
      metadataError = "error in response.text()";
    }
  } else if (error?.message) {
    description = error.message;
    metadataError = JSON.stringify(error);
  } else {
    metadataError = JSON.stringify(error);
  }

  // Incident object
  const obj = {
    title: "Storefront Error " + (status || "GraphQL"),
    app_id: "crane",
    level: "minor",
    description,
    module: "storefront",
    tags: [],
    recorded_at: currentdate,
    organization_id: vueOrgId,
    metadata: {
      authHeader: authHeader ? authHeader() : "",
      body: params,
      error: metadataError,
      url,
      status,
      platform: userAgent.platform,
      appVersion: userAgent.appVersion,
      appCodeName: userAgent.appCodeName,
    },
  };

  /*try {
    await doPostOne({ one: obj });
  } catch (incidentErr) {
    console.log("Error while posting incident", incidentErr);
  }*/

  throw { message: description, status };
};
